import styled from "styled-components";

type AlignItemsType = "center" | "flex-end" | "flex-start";
type JustifyContentType =
  | "center"
  | "flex-end"
  | "flex-start"
  | "space-between";

export const StyledFlex = styled.div<{
  alignItems?: AlignItemsType;
  justifyContent?: JustifyContentType;
  mdFlexFlow?: "row" | "column";
}>`
  display: flex;
  align-items: ${props => (props.alignItems ? props.alignItems : "")};
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : ""};

  ${props => props.theme.breakpoints.down("md")} {
    flex-flow: ${props => (props.mdFlexFlow ? props.mdFlexFlow : "")};
  }
`;

export const StyledInputLabel = styled.label<{ hasError: boolean }>`
  color: ${props => props.theme.palette.secondary.main};
  display: inline-block;
`;

export const StyledDetailWrapper = styled.div`
  width: 900px;
  max-width: calc(100vw - 150px);
  background-color: #fff;
  padding: ${props => props.theme.spacing(4, 3)};
  margin-top: ${props => props.theme.spacing(3)}px;
  box-shadow: ${props => props.theme.shadow.primary};

  ${props => props.theme.breakpoints.down("xs")} {
    max-width: calc(100vw - ${props => props.theme.spacing(2)}px);
    padding: ${props => props.theme.spacing(3, 2)};
    margin: ${props => props.theme.spacing(3, 1)};
  }
`;
